import React, { useState } from "react";
import Validator from "../../services/Validator";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import Api from "../../services/ApiService";

/**
 * PersonalComponent
 * 
 * form for filling personal information
 * 
 * @param {props} setStep - setter for step object in InquaryPage
 * @param {props} data - object for sending data
 * @param {props} setData - setter for object data
 * 
 * @returns next step
 */
const PersonalComponent = ({ data, setData, setStep }) => {

    const publicApi = new Api();
    const VALIDATOR = new Validator();
    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState({});

    // this fields are set on basic registration. Every of this fields are not changable
    const isCompany = data.partner.company_type === "person" ? false : true;
    const max_date = new Date().toISOString().split("T")[0]; // maximum date for datepicker max is today


    /**
     * Handlers
     */
    // Button "weiter" click. Sets personal object to Inquary page and shows next screen
    const handleSubmit = async(e) => {
        e.preventDefault();
        const allErrors = {};
        // checks
        if (data.partner.x_anrede === "" && !isCompany) allErrors.x_anrede = "Dieses Feld ist erforderlich";
        if (data.partner.name === "" && !isCompany) allErrors.name = "Dieses Feld ist erforderlich";
        if (data.partner.lastName === "" && !isCompany) allErrors.lastName = "Dieses Feld ist erforderlich";
        if (!VALIDATOR.dateValid(data.partner.x_birthdate) && !isCompany) allErrors.x_birthdate = "Dieses Feld ist erforderlich";
        if (!VALIDATOR.olderThan18(data.partner.x_birthdate) && !isCompany) allErrors.x_birthdate = "Bitte geben Sie Ihr Geburtsdatum ein. Um Poolmitglied zu werden, müssen Sie mindestens 18 Jahre alt sein";
        if (data.partner.x_mobile === "") allErrors.x_mobile = "Dieses Feld ist erforderlich";
        if (data.partner.x_firmenbuch_nr === "" && isCompany && !data.partner.noFn) allErrors.x_firmenbuch_nr = "Falsche Firmenbuchnummer";
        if (!VALIDATOR.vatValid(data.partner.vat) && isCompany && !data.partner.noVat) allErrors.vat = "Falsche Steueridentifikationsnummer";
        
        if (isCompany && !data.partner.noVat) {
            try {
                let res = await publicApi.checkVat(data.partner.vat);
                let valid = res.data.valid;
                if (!valid) allErrors.vat = "UID konnte nicht gefunden werden";
            } catch (error) {
                allErrors.vat = "UID konnte nicht gefunden werden";
            }
        }


        if (Object.keys(allErrors).length > 0) {
            return setErrors(allErrors);
        }
        setStep(3)
    }


    // Views
    return (
        <Form validated={validated} onSubmit={e => handleSubmit(e)}>
            <Row className="mb-3">
                <Col xs="12">
                    <h5 className="text-energo">Persönliche Daten</h5>
                </Col>
            </Row>
            <Row className="align-items-center">
                <Col xs="12" md="6" xl="4">
                    <Form.Group>
                        <FloatingLabel label="Anrede">
                            <Form.Select
                                disabled={isCompany}
                                size="lg"
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, x_anrede: e.target.value })
                                    }))
                                }}
                                defaultValue={isCompany ? "Firma" : data.partner.x_anrede}
                                isValid={data.partner.x_anrede !== ""}
                                isInvalid={errors.x_anrede}
                            >
                                <option value=""></option>
                                <option value="Herr">Herr</option>
                                <option value="Frau">Frau</option>
                                <option value="False">Keine Angabe</option>
                                <option
                                    hidden={!isCompany}
                                    value="Firma"
                                >Firma</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs="12" md="6" xl="4" hidden={isCompany}>
                    <Form.Group>
                        <FloatingLabel label="Titel">
                            <Form.Select
                                defaultValue={data.partner.x_title}
                                size="lg" onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, x_title: e.target.value })
                                    }))
                                }}
                            >
                                <option value=""></option>
                                <option value="DDr.">DDr.</option>
                                <option value="DI">DI</option>
                                <option value="DI (FH)">DI (FH)</option>
                                <option value="DI Dr.">DI Dr.</option>
                                <option value="Dipl. Päd.">Dipl. Päd.</option>
                                <option value="Dipl. WI (FH)">Dipl. WI (FH)</option>
                                <option value="Dipl.-Ing.">Dipl.-Ing.</option>
                                <option value="ipl.-Ing. Dr.">Dipl.-Ing. Dr.</option>
                                <option value="Dr.">Dr.</option>
                                <option value="Ing.">Ing.</option>
                                <option value="Ing. Mag.">Ing. Mag.</option>
                                <option value="Mag.">Mag.</option>
                                <option value="Mag. (FH)">Mag. (FH)</option>
                                <option value="Mag. Dr.">Mag. Dr.</option>
                                <option value="Prof.">Prof.</option>
                                <option value="Arch. Dipl. Ing.">Arch. Dipl. Ing.</option>
                                <option value="Univ.-Prof Dr.">Univ.-Prof Dr.</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md={isCompany ? "12": "6"} xl={isCompany ? "8" : "6"}>
                    <Form.Group>
                        <FloatingLabel label={isCompany ? "Unternehmensbezeichnung" : "Vorname"}>
                            <Form.Control
                                type="text"
                                placeholder="Vorname"
                                value={data.partner.name}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, name: e.target.value })
                                    }))
                                }}
                                isValid={data.partner.name !== ""}
                                isInvalid={errors.name}
                            />
                        </FloatingLabel>
                        {errors.name ? <small className="text-danger">{errors.name}</small> : null}
                    </Form.Group>
                </Col>
                <Col xs="12" md="6" xl="6" hidden={isCompany}>
                    <Form.Group >
                        <FloatingLabel label="Nachname">
                            <Form.Control
                                type="text"
                                placeholder="Nachname"
                                value={data.partner.lastName}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, lastName: e.target.value })
                                    }))
                                }}
                                isValid={data.partner.lastName !== ""}
                                isInvalid={errors.lastName}
                            />
                        </FloatingLabel>
                        {errors.lastName ? <small className="text-danger">{errors.lastName}</small> : null}
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-3" hidden={isCompany}>
                <Col xs="12" md="6" xl="4">
                    <Form.Group>
                        <FloatingLabel label="Titel hinten">
                            <Form.Control
                                type="text"
                                placeholder=""
                                value={data.partner.x_title_postfix}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, x_title_postfix: e.target.value })
                                    }))
                                }}
                            />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs="12" md="6" xl="4">
                    <FloatingLabel label="Geburtsdatum">
                        <Form.Control
                            type="date"
                            placeholder="Geburtsdatum"
                            max={max_date}
                            value={data.partner.x_birthdate}
                            onChange={e => {
                                setErrors({}); setData(prev => ({
                                    ...prev,
                                    partner: ({ ...prev.partner, x_birthdate: e.target.value })
                                }))
                            }}
                            isValid={VALIDATOR.dateValid(data.partner.x_birthdate) && VALIDATOR.olderThan18(data.partner.x_birthdate)}
                            isInvalid={errors.x_birthdate}
                        />
                    </FloatingLabel>
                    {errors?.x_birthdate ? <small className="text-danger">{errors.x_birthdate}</small> : null}
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="6" xl="6">
                    <Form.Group>
                        <FloatingLabel label="E-Mail">
                            <Form.Control
                                type="email"
                                placeholder="E-Mail"
                                disabled
                                readOnly
                                value={data.partner.email}
                            />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs="12" md="6" xl="6">
                    <Form.Group>
                        <FloatingLabel label="Telefonnummer">
                            <Form.Control
                                type="phone"
                                placeholder="Telefonnummer"
                                value={data.partner.x_mobile}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, x_mobile: e.target.value })
                                    }))
                                }}
                                isValid={data.partner.x_mobile !== "" && data.partner.x_mobile.length > 4}
                                isInvalid={errors.x_mobile}
                            />
                        </FloatingLabel>
                        {errors.x_mobile ? <small className="text-danger">{errors.x_mobile}</small> : null}
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-5" hidden={!isCompany}>
                <h5 className="text-energo">Firmen Daten</h5>
                <Col xs="12" md="12" lg="6" className="mt-3">
                    <Form.Check
                        label="Nicht im Firmenbuch eingetragen"
                        checked={data.partner.noFn}
                        onChange={e => setData(prev => ({...prev, 
                            partner: ({...prev.partner, 
                                noFn: e.target.checked,
                                x_firmenbuch_nr: ""
                            })
                        }))}
                    />
                </Col>
                <Col xs="12" md="12" lg="6" className="mt-3">
                    <Form.Check
                        label="Kleinunternehmen/Keine UID"
                        checked={data.partner.noVat}
                        onChange={e => setData(prev => ({...prev, 
                            partner: ({...prev.partner, 
                                noVat: e.target.checked,
                                vat: ""
                            })
                        }))}
                    />
                </Col>
                <Col xs="12" md="6" lg="6" className="mt-3">
                    <Form.Group>
                        <FloatingLabel label="Firmenbuchnummer">
                            <Form.Control
                                type="text"
                                disabled={data.partner.noFn}
                                placeholder="FN xxxxxx"
                                value={data.partner.x_firmenbuch_nr}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, x_firmenbuch_nr: e.target.value.toUpperCase() })
                                    }))
                                }}
                                isValid={VALIDATOR.StringLength(3, 20, data.partner.x_firmenbuch_nr)}
                                isInvalid={errors.x_firmenbuch_nr}
                            />
                        </FloatingLabel>
                        {errors.x_firmenbuch_nr ? <small className="text-danger">{errors.x_firmenbuch_nr}</small> : null}
                    </Form.Group>
                </Col>
                <Col xs="12" md="6" lg="6" className="mt-3">
                    <Form.Group>
                        <FloatingLabel label="UID">
                            <Form.Control
                                type="text"
                                disabled={data.partner.noVat}
                                placeholder="ATU12345678"
                                value={data.partner.vat}
                                onChange={e => {
                                    setErrors({}); setData(prev => ({
                                        ...prev,
                                        partner: ({ ...prev.partner, vat: e.target.value.toUpperCase() })
                                    }))
                                }}
                                isValid={VALIDATOR.vatValid(data.partner.vat)}
                                isInvalid={errors.vat}
                            />
                        </FloatingLabel>
                        {errors.vat !== undefined ? <small className="text-danger">{errors.vat}</small> : null}
                    </Form.Group>
                </Col>
            </Row>

            <Row>
                <Col className="text-end mt-5">
                    <Button variant="warning" onClick={() => setStep(1)} style={{ marginRight: 5 }}>Zurück</Button>
                    <Button type="submit" className="btn-energo">Weiter</Button>
                </Col>
            </Row>
        </Form>
    )
}
export default PersonalComponent;